import { render, staticRenderFns } from "./history.vue?vue&type=template&id=a64f8348&scoped=true&lang=html&"
import script from "./history.vue?vue&type=script&lang=js&"
export * from "./history.vue?vue&type=script&lang=js&"
import style0 from "./history.vue?vue&type=style&index=0&id=a64f8348&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64f8348",
  null
  
)

component.options.__file = "history.vue"
export default component.exports